import { SamplePack } from '@arpeggi/shared'
import { Box, theme } from '@arpeggi/ui'
import { FC, useContext, useState } from 'react'
import { SoundsTable } from '../../../__legacy__/components/platform/new-explore/components/Table'
import Tabs from '../../../__legacy__/components/platform/new-explore/components/Tabs'
import { SearchContext } from '../../../__legacy__/components/platform/new-explore/hooks/useSearch'
import { SpSamplesTabContext } from '../context'
import { useColorThief, useSPSamplesSectionContent } from '../hooks'
import { Section, TokenGatedEmptyState } from '../primitives'
import { SectionEmptyState } from './SectionEmptyState'

const EmptyStateTable: FC<{ sp: SamplePack }> = ({ sp }) => {
  const { handleEmptyStateClick } = useContext(SpSamplesTabContext)
  return (
    <Box>
      <TokenGatedEmptyState.OpacityGradientContainer>
        <Box css={{ width: '100%', maxHeight: '300px' }}>
          <Table />
        </Box>
      </TokenGatedEmptyState.OpacityGradientContainer>
      <SectionEmptyState
        onClick={handleEmptyStateClick}
        artistName={sp.user.displayName}
        title="Samples are token gated. Collect a token to download sounds."
      />
    </Box>
  )
}

const Table: FC = () => {
  const { defaultFilters } = useContext(SpSamplesTabContext)
  const search = useState()
  return (
    <SearchContext.Provider value={search}>
      <SoundsTable defaultFilters={defaultFilters} />
    </SearchContext.Provider>
  )
}

export const SPSamplesTabContent: FC<{ sp: SamplePack }> = ({ sp }) => {
  const context = useSPSamplesSectionContent(sp)
  const { palette } = useColorThief(sp.coverImage.url)
  const color = palette ? palette[1] : theme.colors.blackA100.value
  return (
    <SpSamplesTabContext.Provider value={context}>
      <Tabs.Content value="#samples">
        <Section.Root>
          <Section.Flare1 css={{ color }} />
          <Section.Flare2 css={{ color }} />
          <Section.Content css={{ paddingTop: '0' }}>
            {context.canViewSamples && <Table />}
            {!context.canViewSamples && <EmptyStateTable sp={sp} />}
          </Section.Content>
        </Section.Root>
      </Tabs.Content>
    </SpSamplesTabContext.Provider>
  )
}
